import React, { useCallback, useMemo, memo } from 'react';
import styled from 'styled-components';
import WithSeparator from 'react-with-separator';

import AddFieldButton from 'components/AddFieldButton';
import HorizontalRuler from 'components/HorizontalRuler';
import Fieldset from 'components/Fieldset';
import { Action } from 'state';
import FieldType from 'types/FieldType';
import Section from 'types/Section';
import MultiSelectFieldForm from '../MultiSelectFieldForm';
import NumericFieldForm from '../NumericFieldForm';
import SingleSelectFieldForm from '../SingleSelectFieldForm';
import TextAreaFieldForm from '../TextAreaFieldForm';
import TextFieldForm from '../TextFieldForm';

const StyledButtons = styled.div`
  display: flex;
  justify-content: flex-end;

  margin-top: 1rem;
`;

interface SectionFieldsProps {
  section: Section;
  dispatch: (action: Action) => void;
}

const SectionFields: React.FC<SectionFieldsProps> = ({ section, dispatch }) => {
  const handleOnClickAddField = useCallback(
    (fieldType: FieldType) => {
      dispatch({ type: 'add-field', section, fieldType });
    },
    [dispatch, section],
  );

  const rootFields = useMemo(() => section.exam_fields.filter((f) => !f.parent_uuid), [section]);

  return (
    <Fieldset legend="Fields">
      <WithSeparator separator={<HorizontalRuler />}>
        {rootFields.map((field) => {
          if (field.input_type === FieldType.SINGLE_SELECT) {
            return <SingleSelectFieldForm key={field.uuid} section={section} field={field} dispatch={dispatch} />;
          } else if (field.input_type === FieldType.TEXT) {
            return <TextFieldForm key={field.uuid} sectionUuid={section.uuid} field={field} dispatch={dispatch} />;
          } else if (field.input_type === FieldType.TEXT_AREA) {
            return <TextAreaFieldForm key={field.uuid} sectionUuid={section.uuid} field={field} dispatch={dispatch} />;
          } else if (field.input_type === FieldType.NUMERIC) {
            return <NumericFieldForm key={field.uuid} sectionUuid={section.uuid} field={field} dispatch={dispatch} />;
          }
          return <MultiSelectFieldForm key={field.uuid} section={section} field={field} dispatch={dispatch} />;
        })}
      </WithSeparator>
      {rootFields.length > 0 && <HorizontalRuler />}
      {!section.credits && (
        <StyledButtons>
          <AddFieldButton onClick={handleOnClickAddField} />
        </StyledButtons>
      )}
    </Fieldset>
  );
};

export default memo(SectionFields);
